import { Show } from 'shared';

import { useIsCoachMode } from '../hooks/useIsCoachMode';

type RenderIfCoachProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export const RenderIfCoach = ({ children, fallback }: RenderIfCoachProps) => {
  const isCoachMode = useIsCoachMode();

  return (
    <Show when={isCoachMode} fallback={fallback}>
      {children}
    </Show>
  );
};
